<ng-container *ngIf="browserIsCompatible; else incompatible">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #incompatible>
  <ng-container>
    <h1>Internet Explorer is not supported</h1>
    <div>
      <span> Supported Browsers: </span>
      <ul>
        <li> Edge </li>
        <li> Firefox </li>
        <li> Chrome </li>
      </ul>
    </div>
  </ng-container>
</ng-template>
